/* ============================================================
   CHIKENKOOP MOTION LIBRARY (Agent A2)
   Vanilla JS, no framework, no jQuery, no imports.
   - Scroll reveal: .ck-reveal (translateY 12px -> 0, opacity 0 -> 1)
   - Lazy video init: .ck-cce-clip (data-src -> src, autoplay on intersect)
   - Subtle parallax: .ck-parallax-img (translateY scroll-bound)
   - Honors prefers-reduced-motion: reduce
   - Fail-silent. Never throws on pages without these classes.
   ============================================================ */
(function () {
  'use strict';

  function init() {
    var reduceMotion = false;
    try {
      reduceMotion = window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      reduceMotion = false;
    }

    var hasIO = typeof window.IntersectionObserver !== 'undefined';

    /* --------------------------------------------------------
       1. Scroll reveal - .ck-reveal
       -------------------------------------------------------- */
    function initReveal() {
      var els = document.querySelectorAll('.ck-reveal');
      if (!els || els.length === 0) return;

      if (reduceMotion || !hasIO) {
        // Reveal everything immediately, no animation.
        for (var i = 0; i < els.length; i++) {
          els[i].classList.add('is-visible');
        }
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var entry = entries[i];
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        }
      }, { threshold: 0.15 });

      for (var j = 0; j < els.length; j++) {
        io.observe(els[j]);
      }
    }

    /* --------------------------------------------------------
       2. Lazy video - .ck-cce-clip
       -------------------------------------------------------- */
    function initLazyVideo() {
      var videos = document.querySelectorAll('video.ck-cce-clip');
      if (!videos || videos.length === 0) return;

      function activate(video) {
        if (!video) return;
        var src = video.getAttribute('data-src');
        if (src && !video.getAttribute('src')) {
          video.setAttribute('src', src);
          try { video.load(); } catch (e) { /* fail silent */ }
        }
        if (!reduceMotion) {
          var p = video.play();
          if (p && typeof p.catch === 'function') {
            p.catch(function () { /* autoplay blocked, fail silent */ });
          }
        }
      }

      if (!hasIO) {
        // No observer - activate all up front.
        for (var i = 0; i < videos.length; i++) activate(videos[i]);
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var entry = entries[i];
          if (entry.isIntersecting) {
            activate(entry.target);
            io.unobserve(entry.target);
          }
        }
      }, { threshold: 0.25 });

      for (var k = 0; k < videos.length; k++) {
        io.observe(videos[k]);
      }
    }

    /* --------------------------------------------------------
       3. Subtle parallax - .ck-parallax-img
       -------------------------------------------------------- */
    function initParallax() {
      if (reduceMotion) return;
      var imgs = document.querySelectorAll('.ck-parallax-img');
      if (!imgs || imgs.length === 0) return;

      var ticking = false;
      var maxOffset = 24; // hard cap so things never drift far

      function update() {
        var y = window.pageYOffset || document.documentElement.scrollTop || 0;
        var raw = y * -0.05;
        var clamped = Math.max(-maxOffset, Math.min(maxOffset, raw));
        for (var i = 0; i < imgs.length; i++) {
          imgs[i].style.transform = 'translate3d(0,' + clamped.toFixed(2) + 'px,0)';
        }
        ticking = false;
      }

      function onScroll() {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      update();
    }

    /* --------------------------------------------------------
       Run all
       -------------------------------------------------------- */
    try { initReveal(); }     catch (e) { /* fail silent */ }
    try { initLazyVideo(); }  catch (e) { /* fail silent */ }
    try { initParallax(); }   catch (e) { /* fail silent */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Tiny namespaced handle for debugging only - no public API.
  window.CKMotion = window.CKMotion || { initialized: true };
})();
